import API from '@/modules/API';

export async function addVirtualDevice(name,companyId,projectId){
    const body = {
        device_name: name,
        company_id: companyId,
        project_id: projectId
    }
    try {
        const url = "https://dashboard-api.tondo-iot.com/device/create/";
        const options = {
            method: "POST",
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                ...API.getAuthHeaders()
            }
        }
        const res = await fetch(url, options);
        const resJson = await res.json();
        return resJson.device_id;
        
    } catch (e) {
        console.log(e);
        return null;
    }
}
export async function deleteVirtualDevice(companyId,projectId,id){
    const body = {
        device_id: id,
        company_id: companyId,
        project_id: projectId
    }
    try {
        const url = "https://dashboard-api.tondo-iot.com/device/delete";
        const options = {
            method: "DELETE",
            body: JSON.stringify(body),
            headers: {
                'Content-Type': 'application/json',
                ...API.getAuthHeaders()
            }
        }
        const res = await fetch(url, options);
        const resJson = await res.json();
        return resJson;
        
    } catch (e) {
        console.log(e);
        
    }
}